<script lang="ts">
    import * as animateScroll from "svelte-scrollto"
    import { generalInfo, currentColorTheme } from "../../store"

    import ColorSwitcher from "./ColorSwitcher.svelte"

    import LanguageChooser from "./LanguageChooser.svelte"
    import Navigation from "./Navigation.svelte"
</script>

<footer>
    <div class="wm-container">
        <div class="wm-row">
            <div class="wm-col-md-3">
                <a href="/" class="brand">
                    <img
                        src="/img/brand/logo-weiss.png"
                        alt="{$generalInfo?.company.companyName}"
                        class="brand-white"
                    />
                    <img src="/img/brand/logo.png" alt="{$generalInfo?.company.companyName}" class="brand-red" />
                </a>
                {#if $generalInfo?.company?.companyName}
                    <p>{@html $generalInfo?.company?.companyName}</p>
                {/if}
                {#if $generalInfo?.company?.companyDescription}
                    <p>{@html $generalInfo?.company?.companyDescription}</p>
                {/if}
                {#if $generalInfo?.company?.companyAddresses[0]?.email}
                    <a href="mailto:{$generalInfo?.company?.companyAddresses[0]?.email}" class="email">
                        {$generalInfo?.company?.companyAddresses[0]?.email}
                    </a>
                {/if}

                <div class="social-icons">
                    {#if $generalInfo?.company?.facebookUrl}
                        <a href="{$generalInfo?.company?.facebookUrl}">
                            <img src="/img/icons/facebook.svg" alt="{$generalInfo?.company?.facebookUrl}" />
                        </a>
                    {/if}
                    {#if $generalInfo?.company?.instagramUrl}
                        <a href="{$generalInfo?.company?.instagramUrl}">
                            <img src="/img/icons/instagram.svg" alt="{$generalInfo?.company?.instagramUrl}" />
                        </a>
                    {/if}
                </div>
            </div>
            <div class="wm-col-md-3">
                {#if $generalInfo?.company?.companyAddresses[0]?.postcode && $generalInfo?.company?.companyAddresses[0]?.city && $generalInfo?.company?.companyAddresses[0]?.street && $generalInfo?.company?.companyAddresses[0]?.houseNumber && $generalInfo?.company?.companyAddresses[0]?.tel}
                    <p>
                        {$generalInfo?.company?.companyAddresses[0]?.postcode}&nbsp;
                        {$generalInfo?.company?.companyAddresses[0]?.city} . {$generalInfo?.company?.companyAddresses[0]
                            ?.street}
                        {$generalInfo?.company?.companyAddresses[0]?.houseNumber}<br />
                        {$generalInfo?.company?.companyAddresses[0]?.tel}
                    </p>
                {/if}
            </div>
            <div class="wm-col-md-3">
                {#if $generalInfo?.company?.companyAddresses[1]?.postcode && $generalInfo?.company?.companyAddresses[1]?.city && $generalInfo?.company?.companyAddresses[1]?.street && $generalInfo?.company?.companyAddresses[1]?.houseNumber && $generalInfo?.company?.companyAddresses[1]?.tel}
                    <p>
                        {$generalInfo?.company?.companyAddresses[1]?.postcode}&nbsp;
                        {$generalInfo?.company?.companyAddresses[1]?.city} . {$generalInfo?.company?.companyAddresses[1]
                            ?.street}
                        {$generalInfo?.company?.companyAddresses[1]?.houseNumber}<br />
                        {$generalInfo?.company?.companyAddresses[1]?.tel}
                    </p>
                {/if}
            </div>
            <div class="wm-col-md-3">
                <Navigation ident="footer" />
                <LanguageChooser />
                <ColorSwitcher />
            </div>
        </div>
    </div>

    <img
        src="/img/icons/bi_arrow-up.svg"
        alt=""
        class="scroll-top"
        on:click="{() => animateScroll.scrollToTop()}"
        on:keypress
    />
</footer>
